/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    dialogOverride: {
        padding: '20px',
        color: 'black',
    },
    okButton: {
        backgroundColor: theme.palette.text.mainGreen,
        borderColor: theme.palette.text.mainGreen,
        textTransform: 'uppercase',
        minWidth: '66px',
        '&:focus-visible': {
            outline: 'none',
            border: '2px dashed #4F7E1D !important',
            borderRadius: '3px',
        },
        '&:hover': {
            backgroundColor: theme.palette.text.mainGreen,
            borderColor: theme.palette.text.mainGreen,
        },
        '&:focus': {
            backgroundColor: theme.palette.text.mainGreen,
            borderColor: theme.palette.text.mainGreen,
        },
        '&:active': {
            backgroundColor: theme.palette.text.mainGreen,
        },
    },
    cancelButton: {
        textTransform: 'uppercase',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
}));
const WarningModal = ({ visibility, title, message, confirmButtonText, onConfirmation, cancelButtonText, onCancel }) => {
    const classes = useStyles();
    return (
        <Dialog open={visibility} onClose={onConfirmation} aria-labelledby="confirm-status-update-dialog" className={classes.dialogOverride}>
            {title && <DialogTitle id="form-dialog-title">{title}</DialogTitle>}
            {message && (
                <DialogContent>
                    <DialogContentText>{message}</DialogContentText>
                </DialogContent>
            )}
            <DialogActions>
                {cancelButtonText && (
                    <Button disableFocusRipple variant="outlined" onClick={onCancel} className={classes.cancelButton}>
                        {cancelButtonText}
                    </Button>
                )}
                <Button disableFocusRipple className={classes.okButton} variant="contained" onClick={onConfirmation}>
                    {confirmButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WarningModal;
